import React, { useContext, useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import styles from "./Header.module.css";
import FunctionalButton from "../button/FunctionalButton";

function Header({ showNavigation }) {
  const [role, setRole] = useState("");
  const { signOut, user } = useContext(AuthContext);
  let navigate = useNavigate();

  const blueContainer = useRef();

  // Based on the user role we show a specified menu
  useEffect(() => {
    async function confirmUser() {
      setRole(user.role);
    }
    if (user !== null) {
      confirmUser();
    }
  }, [user]);

  // When clicking the logo go to the search page (this is the main page after login).
  function goToSearchPage() {
    navigate("/search");
  }

  // On the day before Kingsday and on Kingsday itself we change the blue containter to orange just like in the previewer.
  useEffect(() => {
    const date = new Date();
    const currentDay = date.getDate();
    const currentMonth = date.getMonth() + 1;
    if (
      (currentDay === 26 && currentMonth === 4) ||
      (currentDay === 27 && currentMonth === 4)
    ) {
      blueContainer.current.style.backgroundColor = "var(--kingsday-orange)";
    }
  }, []);

  return (
    <div className={styles["navigation-container"]}>
      <div className={styles["blue-container"]} ref={blueContainer}>
        <div className={styles["header-container"]}>
          {showNavigation && (
            <div
              className={styles["logo-container"]}
              id={styles["logo-container"]}
              onClick={goToSearchPage}
            >
              <svg className={styles["w-logo"]}>
                <g style={{ fill: "#c1002a" }}>
                  <g data-name="weborama w">
                    <path
                      d="M54,939.75a2.56,2.56,0,0,1-2.23,1.54H46.27a2.54,2.54,0,0,1-2.21-1.55l-2.4-6.5c-0.31-.85-0.81-0.85-1.12,0l-2.29,6.48a2.5,2.5,0,0,1-2.19,1.55H30.52a2.61,2.61,0,0,1-2.25-1.53l-5.75-14.6a1,1,0,0,1,1-1.53h3.88a2.42,2.42,0,0,1,2.15,1.57l3.13,9.67c0.28,0.86.77,0.87,1.08,0l3.64-9.71a2.56,2.56,0,0,1,2.22-1.54h2.8a2.55,2.55,0,0,1,2.22,1.55l3.61,9.71c0.32,0.85.8,0.84,1.07,0l3.05-9.66a2.4,2.4,0,0,1,2.14-1.57h3.88a1.06,1.06,0,0,1,1.06,1.54Z"
                      transform="translate(-22.41 -918.3)"
                    />
                  </g>
                </g>
              </svg>
              <p>weborama</p>
            </div>
          )}

          {!showNavigation && (
            <div className={styles["logo-container"]}>
              <svg className={styles["w-logo"]}>
                <g style={{ fill: "#c1002a" }}>
                  <g data-name="weborama w">
                    <path
                      d="M54,939.75a2.56,2.56,0,0,1-2.23,1.54H46.27a2.54,2.54,0,0,1-2.21-1.55l-2.4-6.5c-0.31-.85-0.81-0.85-1.12,0l-2.29,6.48a2.5,2.5,0,0,1-2.19,1.55H30.52a2.61,2.61,0,0,1-2.25-1.53l-5.75-14.6a1,1,0,0,1,1-1.53h3.88a2.42,2.42,0,0,1,2.15,1.57l3.13,9.67c0.28,0.86.77,0.87,1.08,0l3.64-9.71a2.56,2.56,0,0,1,2.22-1.54h2.8a2.55,2.55,0,0,1,2.22,1.55l3.61,9.71c0.32,0.85.8,0.84,1.07,0l3.05-9.66a2.4,2.4,0,0,1,2.14-1.57h3.88a1.06,1.06,0,0,1,1.06,1.54Z"
                      transform="translate(-22.41 -918.3)"
                    />
                  </g>
                </g>
              </svg>
              <p className={styles["weborama-name"]}>weborama</p>
            </div>
          )}
          {showNavigation && (
            <nav>
              {user && (
                <ul>
                  <>
                    {role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/search"
                        >
                          Search
                        </NavLink>
                      </li>
                    )}

                    {role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/insert"
                        >
                          Insert new specsheet
                        </NavLink>
                      </li>
                    )}

                    {user.role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/users"
                        >
                          Manage Users
                        </NavLink>
                      </li>
                    )}

                    {user.role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/formsettings"
                        >
                          Form Settings
                        </NavLink>
                      </li>
                    )}

                    <li>
                      <FunctionalButton type="button" handleClick={signOut}>
                        Sign out
                      </FunctionalButton>
                    </li>
                  </>
                </ul>
              )}
            </nav>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
